// Compare editable invoice data, not lookup labels, stock previews or generated UI ids.
const number = (value, fallback = null) => value == null || value === '' ? fallback : Number(value);
const text = value => value == null ? '' : String(value);
const date = value => text(value).slice(0, 10);
const allocation = rows => (rows || []).map(g => ({ line_index: number(g.line_index), account_id: number(g.account_id),
  allocations: (g.allocations || []).map(a => ({ cost_center_id: number(a.cost_center_id),
    amount: number(a.amount), percent: number(a.percent) })).sort((a, b) => a.cost_center_id - b.cost_center_id),
})).sort((a, b) => a.line_index - b.line_index || a.account_id - b.account_id);

export function normalizeIesire(m) {
  if (!m) return null;
  const result = {};
  for (const key of ['tip_document', 'doc_serie', 'doc_no', 'observatii', 'comanda_client', 'proiect_client']) result[key] = text(m[key]);
  for (const key of ['doc_date', 'bxdatascadenta']) result[key] = date(m[key]);
  for (const key of ['contact_id', 'cont_id', 'tip_factura_iesire_id', 'branch_id', 'bxvaluta_curs', 'bxcurs_invoice', 'deviz_id']) result[key] = number(m[key]);
  const details = m.print_details || {};
  result.print_details = {};
  for (const key of ['payment_other','prepared_by','delegate_name','delegate_series','delegate_number','transport','registration']) result.print_details[key] = text(details[key]);
  result.print_details.payment_method = details.payment_method || 'OP';
  result.print_details.penalty_percent = number(details.penalty_percent);
  result.bxvaluta_id = number(m.bxvaluta_id, 1);
  result.bxsoldint = number(m.bxsoldint, 0);
  result.e_tva_inc = m.e_tva_inc === true || Number(m.e_tva_inc) === 1;
  result.bxfinal_bool = m.bxfinal_bool === true || Number(m.bxfinal_bool) === 1;
  result.linii = (m.linii_lns || m.linii || []).map(ln => {
    const line = { descriere: text(ln.descriere), serii: ln.serii || [] };
    for (const key of ['bxpart_id', 'bxgestiune_id', 'cont_venit_id', 'cont_tva_id', 'cont_client_id', 'bxstocin_id', 'storno_source_line_id']) line[key] = number(ln[key]);
    for (const key of ['qty', 'price', 'vat_rate']) line[key] = number(ln[key], 0);
    return line;
  });
  const allocations = allocation(m.cost_allocation);
  const baseline = allocation(m._allocationBaseline);
  result.cost_allocation = JSON.stringify(allocations) === JSON.stringify(baseline) ? [] : allocations;
  return result;
}
